import { render } from "./AddPayrollDeductions.vue?vue&type=template&id=d220f75c&scoped=true"
import script from "./AddPayrollDeductions.vue?vue&type=script&lang=js"
export * from "./AddPayrollDeductions.vue?vue&type=script&lang=js"

import "./AddPayrollDeductions.vue?vue&type=style&index=0&id=d220f75c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d220f75c"]])

export default __exports__